export const viewport = {
    tablet: '768px',
    desktop: '1024px',
    largeDesktop: '1440px'
}
